import DOMPurify from "dompurify";

const SanitizeHTML = ({ html }: { html: string }) => {
    const sanitize = (dirty: string) => {
        return {
            __html: DOMPurify.sanitize(
                dirty
            )
        }
    };
    return <div dangerouslySetInnerHTML={sanitize(html)} />
};

export default SanitizeHTML;